import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-area-label',
    templateUrl: './area-label.component.html',
    styleUrls: ['./area-label.component.less']
})
export class AreaLabelComponent {
    @Input() nome: string;
    @Input() fontSize = '12px';
}
